<div
  class="card card--color-{{ config.colorIndex }}"
  [class.card--accent]="config.accent"
  [@cardAnim]
  (click)="onClickCard()"
>
  @if ( (isDataPointCard(config) || isTimeSeriesCard(config) ||
  isPieChartCard(config)) && config.info ) {
  <button
    class="info-button"
    [matTooltip]="config.info | formatNumbersText"
    [matTooltipClass]="'card-info-tooltip'"
    #tooltip="matTooltip"
    (click)="showTooltip($event, tooltip)"
  >
    <mat-icon fontSet="material-symbols-outlined">info</mat-icon>
  </button>
  } @if (isDataPointCard(config)) {
  <app-data-point-card-content [config]="config"></app-data-point-card-content>
  } @else if(isTimeSeriesCard(config)) {
  <app-time-series-card-content
    [config]="config"
  ></app-time-series-card-content>
  } @else if (isPieChartCard(config)) {
  <app-pie-chart-card-content [config]="config"></app-pie-chart-card-content>
  } @else if (isTitleCard(config)) {
  <app-title-card-content [config]="config"></app-title-card-content>
  }

  <!-- @if (hideMenuActive) {
  <div class="hide-menu" [@hideMenuAnim] (click)="$event.stopPropagation()">
    <div class="col" (click)="onClickReturnCard()">
      <mat-icon>arrow_back</mat-icon>
      <span>Revenir</span>
    </div>
    <div class="separator"></div>
    <div class="col" (click)="onClickHide()">
      <mat-icon>visibility_off</mat-icon>
      <span>Cacher</span>
    </div>
  </div>
  } -->
</div>
